var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-window',_vm._g(_vm._b({model:{value:(_vm.windowItemIndex),callback:function ($$v) {_vm.windowItemIndex=$$v},expression:"windowItemIndex"}},'v-window',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }